import styled from 'styled-components'

export const Container = styled.div`
  background-color: #ffc706;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

export const Content = styled.div`
  text-align: center;
`;

export const Logo = styled.img`
  width: auto;
  height: 100px;
  margin-bottom: 20px;
  margin-bottom: 50px;

  &:first-child {
    margin-right: 50px;
  }
`;

export const ImageSize = styled.img`
  width: auto;
  height: 100vh;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  text-align: left;
  margin: auto;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
`;

export const Input = styled.input`
  padding: 10px;
  color: black;
  width: 500px;
  margin-right: auto;
  font-size: 1em;
`;

export const Label = styled.label`
  color: black;
  margin-bottom: 5px;
  width: 330px;
  margin-right: auto;
  font-size: 20px;
  font-weight: bold;
`;

export const ErrorLabel = styled.label`
  color: red;
  margin-top: 0px;
  font-size: 14px;
`;

export const Button = styled.button`
  background-color: white;
  color: black;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  width: 300px;
  margin: auto;
  margin-top: 120px;
  font-size: 20px;
  font-weight: bold;
  border-radius: 5px;
`;

export const ButtonLogoff = styled.button`
  background-color: white;
  color: black;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  width: 80px;
  margin: auto;
  margin-bottom: 10px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 5px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
`;

export const TitleDiv = styled.div`
  width: 80%;
  margin: auto;
  font-size: 1.6em;
  color: black;
  text-align: justify;
  word-spacing: -2px;
  line-height: 40px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: -80px;
`;

export const ButtonSistema = styled(Button)`
  font-size: 11px;
  max-width: 100px;
`;